import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74e8b000"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import { storeToRefs } from 'pinia';


import AccountSvg from '@/assets/images/Svgs/AccountSvg.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import LoginSvg from '@/assets/images/Svgs/LoginSvg.vue';
import LogoutSvg from '@/assets/images/Svgs/LogoutSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';



export default /*#__PURE__*/_defineComponent({
  __name: 'IconButtons',
  setup(__props) {

const { isImageMode } = storeToRefs(useCommonStore());
const {
  imageModeToggle,
  showLoginToggle,
  disabledQualification,
  windowSize,
  showPanel,
} = useCommonStore();
const { accessedMemberInfo, accessLogout } = useMemberStore();

const showMobileAccountToggle = (): void => {
  showPanel.isMobileAccountInfo = !showPanel.isMobileAccountInfo;
};

/**
 * 로그아웃 기능을 실행합니다.
 */
const submitLogout = (): void => {
  accessLogout();

  if (showPanel.isEditPassword) {
    showPanel.isEditPassword = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (!_unref(isImageMode) && _unref(windowSize).width < _unref(windowSize).height)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["icon_buttons", {'opacity': _unref(disabledQualification)()}])
          }, [
            (_unref(accessedMemberInfo).name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ 'account_btn' : _unref(showPanel).isMobileAccountInfo }),
                    disabled: _unref(disabledQualification)(),
                    onClick: showMobileAccountToggle
                  }, [
                    _createElementVNode("span", null, [
                      _createVNode(AccountSvg)
                    ]),
                    _createTextVNode(" ACCOUNT ")
                  ], 10, _hoisted_1),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _unref(disabledQualification)(),
                    onClick: submitLogout
                  }, [
                    _createElementVNode("span", null, [
                      _createVNode(LogoutSvg)
                    ]),
                    _createTextVNode(" LOGOUT ")
                  ], 8, _hoisted_2)
                ], 64))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: _normalizeClass({ 'login_button_active' : _unref(showPanel).isLogin }),
                  disabled: _unref(disabledQualification)(),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showLoginToggle) && _unref(showLoginToggle)(...args)))
                }, [
                  _createElementVNode("span", null, [
                    _createVNode(LoginSvg)
                  ]),
                  _createTextVNode(" LOGIN ")
                ], 10, _hoisted_3)),
            (!_unref(isImageMode))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  disabled: _unref(disabledQualification)(),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(imageModeToggle) && _unref(imageModeToggle)(...args)))
                }, [
                  _createElementVNode("span", null, [
                    _createVNode(ImageModeSvg)
                  ]),
                  _createTextVNode(" IMAGE MODE ")
                ], 8, _hoisted_4))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})